import { MGPFallible, MGPValidation } from '@everyboard/lib';
import { MoveCoordToCoord } from '../../jscaip/MoveCoordToCoord';
import { MoveWithTwoCoords } from '../../jscaip/MoveWithTwoCoords';
import { RulesFailure } from '../../jscaip/RulesFailure';
import { TriangularCheckerBoard } from '../../jscaip/state/TriangularCheckerBoard';
import { SaharaFailure } from './SaharaFailure';
export class SaharaMove extends MoveCoordToCoord {
    static encoder = MoveWithTwoCoords.getFallibleEncoder(SaharaMove.from);
    static checkDistanceAndLocation(start, end) {
        const distance = start.getOrthogonalDistance(end);
        if (distance === 0) {
            return MGPValidation.failure(RulesFailure.MOVE_CANNOT_BE_STATIC());
        }
        else if (distance === 1) {
            const fakeNeighbors = TriangularCheckerBoard.getFakeNeighbors(start);
            if (end.equals(fakeNeighbors)) {
                return MGPValidation.failure(SaharaFailure.THOSE_TWO_SPACES_ARE_NOT_NEIGHBORS());
            }
        }
        else if (distance === 2) {
            if (TriangularCheckerBoard.isSpaceDark(start)) {
                return MGPValidation.failure(SaharaFailure.CAN_ONLY_REBOUND_ON_BLACK());
            }
            if (start.x === end.x) {
                return MGPValidation.failure(SaharaFailure.THOSE_TWO_SPACES_HAVE_NO_COMMON_NEIGHBOR());
            }
        }
        else {
            return MGPValidation.failure($localize `You can move one or two spaces, not ${distance}.`);
        }
        return MGPValidation.SUCCESS;
    }
    static from(start, end) {
        const validity = SaharaMove.checkDistanceAndLocation(start, end);
        if (validity.isFailure()) {
            return validity.toOtherFallible();
        }
        else {
            return MGPFallible.success(new SaharaMove(start, end));
        }
    }
    constructor(start, end) {
        super(start, end);
    }
    isSimpleStep() {
        const dx = Math.abs(this.getStart().x - this.getEnd().x);
        const dy = Math.abs(this.getStart().y - this.getEnd().y);
        return dx + dy === 1;
    }
    toString() {
        return 'SaharaMove(' + this.getStart() + '->' + this.getEnd() + ')';
    }
}
